export const creditNotesTypes = {
  GET_CREDIT_NOTES_SAT_USAGES: 'GET_CREDIT_NOTES_SAT_USAGES',
  SET_CREDIT_NOTES_FILTERS: 'SET_CREDIT_NOTES_FILTERS',
  GET_CREDIT_NOTES: 'GET_CREDIT_NOTES',
  GET_CLIENT_CREDIT_NOTES: 'GET_CLIENT_CREDIT_NOTES',
  SELECT_ALL_NOTE_TO_CFDI: 'SELECT_ALL_NOTE_TO_CFDI',
  TOGGLE_NOTE_TO_CFDI: 'TOGGLE_NOTE_TO_CFDI',
  DESELECT_ALL_NOTE_TO_CFDI: 'DESELECT_ALL_NOTE_TO_CFDI',
  DO_CREDIT_NOTES: 'DO_CREDIT_NOTES',
  CLEAR_CREDIT_NOTES: 'CLEAR_CREDIT_NOTES',
  GET_DATA_FISCAL: 'GET_DATA_FISCAL',
}